import {
  BANNER_ERROR,
  BANNER_LOADING,
  BANNER_SUCCESS,
} from '../types/BannerTypes';

const initialState = {
  banner: [],
  bannerStatus: 'idle',
};

const bannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case BANNER_LOADING:
      return { ...state, bannerStatus: 'loading' };
    case BANNER_ERROR:
      return { ...state, bannerStatus: 'error' };
    case BANNER_SUCCESS:
      return {
        ...state,
        bannerStatus: 'succeeded',
        banner: action.banner,
      };
    default:
      return state;
  }
};

export default bannerReducer;
